var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNsiNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 98,
    viewBox: "0 0 300 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4265_21614)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.5 -0.5C99.5 -0.5 199.5 -0.5 299.5 -0.5C299.5 32.1667 299.5 64.8333 299.5 97.5C199.5 97.5 99.5 97.5 -0.5 97.5C-0.5 64.8333 -0.5 32.1667 -0.5 -0.5Z",
    fill: "#050403"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.5 1.5C250.572 2.71173 251.905 5.8784 248.5 11C243 12.1667 240.833 10 242 4.5C243.045 3.62656 243.878 2.62656 244.5 1.5Z",
    fill: "#E95203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.5 10.5C241.359 9.07372 243.359 11.0737 241.5 16.5C235.82 18.1536 233.82 16.1536 235.5 10.5Z",
    fill: "#F15403"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.5 10.4998C257.486 10.3308 259.153 13.1641 255.5 18.9998C251.229 20.5124 248.895 19.0124 248.5 14.4998C248.752 12.9269 249.418 11.5936 250.5 10.4998Z",
    fill: "#ED5304"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.5 16.5001C233.321 16.316 234.988 17.6494 235.5 20.5001C233.74 23.9261 231.574 24.2595 229 21.5001C228.387 19.5049 228.887 17.8382 230.5 16.5001Z",
    fill: "#E75104"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.5 17.4999C248.708 17.3689 250.375 19.7023 248.5 24.4999C241.789 25.788 240.123 23.4547 243.5 17.4999Z",
    fill: "#E65003"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.5 18.4999C264.676 17.9845 266.342 20.8178 262.5 26.9999C255.946 26.9565 254.279 24.1232 257.5 18.4999Z",
    fill: "#EA5204"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.5 24.5C224.833 24.5 226.167 24.5 227.5 24.5C227.365 29.9873 225.698 30.654 222.5 26.5C222.863 25.8165 223.196 25.1499 223.5 24.5Z",
    fill: "#E45105"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.5 24.5C242.493 24.997 243.493 27.1637 240.5 31C235.382 30.8242 234.382 28.6576 237.5 24.5Z",
    fill: "#E35003"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.5 25.5C256.488 25.664 257.821 28.164 254.5 33C248.886 32.944 247.553 30.444 250.5 25.5Z",
    fill: "#EE5302"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.5 25.5C271.75 25.8821 273.417 28.7154 270.5 34C262.208 34.89 260.542 32.0567 265.5 25.5Z",
    fill: "#E34F03"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5 29.5C80.9839 28.507 89.6506 28.1736 98.5 28.5C98.7373 29.791 98.404 30.791 97.5 31.5C89.5671 29.5316 81.2337 28.865 72.5 29.5Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.5 28.4999C128.846 28.3342 133.179 28.5009 137.5 28.9999C142.143 31.0723 143.643 34.5723 142 39.4999C140.374 45.2966 138.374 50.9633 136 56.4999C134.269 58.6165 132.102 60.1165 129.5 60.9999C124.5 61.6666 119.5 61.6666 114.5 60.9999C111.852 59.3666 110.519 57.0333 110.5 53.9999C111.608 46.0027 114.274 38.6693 118.5 31.9999C120.727 31.0589 122.727 29.8922 124.5 28.4999Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 60.5C10.2869 60.81 7.2869 60.4767 4.5 59.5C7.77269 49.6787 10.4394 39.6787 12.5 29.5C16.5 29.5 20.5 29.5 24.5 29.5C24.2734 34.6918 25.1067 39.6918 27 44.5C28.0141 39.4449 29.1807 34.4449 30.5 29.5C33.5 29.5 36.5 29.5 39.5 29.5C36.6384 40.0911 33.9718 50.7577 31.5 61.5C27.8333 61.5 24.1667 61.5 20.5 61.5C20.5339 55.7037 19.7006 50.0371 18 44.5C16.759 50.0375 15.259 55.3709 13.5 60.5Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5 60.5001C61.5 60.5001 58.5 60.5001 55.5 60.5001C55.5 58.5001 55.5 56.5001 55.5 54.5001C52.2869 54.1901 49.2869 54.5234 46.5 55.5001C46.1231 57.2581 45.4565 58.9247 44.5 60.5001C41.1667 61.8334 37.8333 61.8334 34.5 60.5001C40.1667 50.5001 45.8333 40.5001 51.5 30.5001C55.7828 29.5079 60.1161 29.1745 64.5 29.5001C64.5 39.8334 64.5 50.1668 64.5 60.5001Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5 29.4999C81.2337 28.8649 89.5671 29.5315 97.5 31.4999C96.7659 32.7078 96.4326 34.0412 96.5 35.4999C93.5525 35.2228 90.7191 35.5561 88 36.4999C85.3573 44.7385 83.1906 53.0719 81.5 61.4999C78.1667 61.4999 74.8333 61.4999 71.5 61.4999C73.2924 52.7884 75.2924 44.1218 77.5 35.4999C75.1667 35.4999 72.8333 35.4999 70.5 35.4999C70.595 33.2142 71.2616 31.2142 72.5 29.4999Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.5 29.5C104.833 29.5 108.167 29.5 111.5 29.5C108.84 40.1418 106.173 50.8085 103.5 61.5C100.167 61.5 96.8333 61.5 93.5 61.5C95.9606 50.7843 98.6272 40.1177 101.5 29.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.5 29.5001C152.5 29.5001 156.5 29.5001 160.5 29.5001C161.114 49.2349 162.78 49.2349 165.5 29.5001C168.898 29.1797 172.232 29.5131 175.5 30.5001C172.357 40.4051 169.524 50.4051 167 60.5001C163.606 61.4559 160.106 61.7893 156.5 61.5001C155.165 40.4769 152.832 40.4769 149.5 61.5001C146.5 61.5001 143.5 61.5001 140.5 61.5001C142.853 50.7539 145.52 40.0872 148.5 29.5001Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.5 60.5001C197.167 60.5001 193.833 60.5001 190.5 60.5001C190.5 59.1668 190.5 57.8334 190.5 56.5001C189.666 55.2522 188.333 54.5855 186.5 54.5001C185.167 54.8334 183.833 55.1668 182.5 55.5001C181.725 57.3965 180.725 59.0631 179.5 60.5001C176.287 60.8101 173.287 60.4768 170.5 59.5001C175.988 49.8608 181.488 40.1941 187 30.5001C191.401 29.5334 195.901 29.2001 200.5 29.5001C200.5 39.8334 200.5 50.1668 200.5 60.5001Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.5 45.5C216.596 46.209 216.263 47.209 216.5 48.5C215.85 50.4352 215.517 52.4352 215.5 54.5C218.5 54.5 221.5 54.5 224.5 54.5C225.833 54.5 226.5 55.1667 226.5 56.5C225.566 57.5676 225.232 58.901 225.5 60.5C223.833 60.5 222.167 60.5 220.5 60.5C219.5 60.5 218.5 60.5 217.5 60.5C212.637 60.8195 207.97 60.4861 203.5 59.5C203.894 55.6528 204.894 51.9861 206.5 48.5C207.11 47.609 207.443 46.609 207.5 45.5C208.535 40.4273 209.868 35.4273 211.5 30.5C214.833 29.1667 218.167 29.1667 221.5 30.5C220.321 35.5513 218.987 40.5513 217.5 45.5Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.5 31.5002C234.071 31.4079 235.238 33.0745 234 36.5002C231.915 37.6471 230.415 36.9805 229.5 34.5002C230.127 33.5834 230.461 32.5834 230.5 31.5002Z",
    fill: "#DA4C03"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.5 32.5C249.466 32.929 250.466 35.0957 247.5 39C242.382 38.8242 241.382 36.6576 244.5 32.5Z",
    fill: "#DF4D03"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.5 33.4999C263.704 33.3136 265.037 35.8136 261.5 40.9999C259.024 41.6801 257.191 40.8468 256 38.4999C255.387 36.5047 255.887 34.838 257.5 33.4999Z",
    fill: "#E65105"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.5 34.4998C128.199 34.3396 129.866 34.5063 131.5 34.9998C132.022 35.5611 132.355 36.2278 132.5 36.9998C130.282 42.7045 128.448 48.5379 127 54.4998C125.274 55.576 123.441 55.7427 121.5 54.9998C120.941 54.2751 120.608 53.4417 120.5 52.4998C122.38 46.3933 124.38 40.3933 126.5 34.4998Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.5 33.5C278.75 33.8821 280.417 36.7154 277.5 42C270.421 42.5273 268.754 39.694 272.5 33.5Z",
    fill: "#EE5303"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.5 36.5C191.745 40.6102 191.745 44.9435 191.5 49.5C189.396 49.7989 187.396 49.4656 185.5 48.5C187.513 44.4734 189.513 40.4734 191.5 36.5Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5 36.5C56.3112 40.6604 56.3112 44.9937 55.5 49.5C53.8333 49.5 52.1667 49.5 50.5 49.5C51.8825 45.0664 53.5492 40.7331 55.5 36.5Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.5 39.5C224.5 39.5 225.5 39.5 226.5 39.5C226.5 40.8333 226.5 42.1667 226.5 43.5C223.45 43.3538 222.45 42.0204 223.5 39.5Z",
    fill: "#E35004"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.5 39.5C238.833 39.5 240.167 39.5 241.5 39.5C241.5 41.1667 241.5 42.8333 241.5 44.5C237.065 45.0776 235.732 43.4109 237.5 39.5Z",
    fill: "#DE4D03"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.5 40.4999C255.123 39.4081 256.956 41.0747 256 45.4999C250.828 47.3148 248.995 45.6482 250.5 40.4999Z",
    fill: "#E55206"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.5 41.4999C271.564 41.3515 272.897 43.8515 268.5 48.9999C262.95 48.6347 261.617 46.1347 264.5 41.4999Z",
    fill: "#E14E03"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.5 41.5C285.75 41.8821 287.417 44.7154 284.5 50C277.416 50.475 275.749 47.6417 279.5 41.5Z",
    fill: "#F05403"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.5 45.5C207.443 46.609 207.11 47.609 206.5 48.5C203.139 47.7968 202.806 46.4635 205.5 44.5C206.183 44.8627 206.85 45.1961 207.5 45.5Z",
    fill: "#C74909"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.5 45.5C220.861 46.2032 221.194 47.5365 218.5 49.5C217.817 49.1373 217.15 48.8039 216.5 48.5C216.263 47.209 216.596 46.209 217.5 45.5Z",
    fill: "#DA4F0A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.5 46.5C231.5 46.5 232.5 46.5 233.5 46.5C233.5 47.8333 233.5 49.1667 233.5 50.5C232.167 50.5 230.833 50.5 229.5 50.5C229.433 49.0413 229.766 47.7079 230.5 46.5Z",
    fill: "#D44A02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.5 47.5C248.409 46.7366 249.742 48.0699 248.5 51.5C247.311 52.4287 245.978 52.762 244.5 52.5C244.5 50.8333 244.5 49.1667 244.5 47.5Z",
    fill: "#E14E02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.5 47.5C262.976 47.8003 264.31 49.9669 262.5 54C256.778 54.4527 255.445 52.286 258.5 47.5Z",
    fill: "#DE4E04"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.5 48.5C277.262 49.0925 278.596 51.5925 276.5 56C270.202 56.4954 268.868 53.9954 272.5 48.5Z",
    fill: "#F15403"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.5 49.5002C293.225 49.2046 294.891 51.8713 291.5 57.5002C284.409 58.5307 282.742 55.8641 286.5 49.5002Z",
    fill: "#EF5303"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.5 54.4998C225.209 53.5958 226.209 53.2625 227.5 53.4998C227.737 54.7908 227.404 55.7908 226.5 56.4998C226.5 55.1665 225.833 54.4998 224.5 54.4998Z",
    fill: "#C54603"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.5 54.5C240.166 54.0658 241.333 55.0658 241 57.5C237.403 59.0661 236.237 58.0661 237.5 54.5Z",
    fill: "#D64C04"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.5 54.5C256.929 55.6656 257.429 57.6656 254 60.5C250.168 59.1984 249.668 57.1984 252.5 54.5Z",
    fill: "#D24902"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.5 55.5C270.014 55.6932 271.347 57.8599 269.5 62C267.888 62.7203 266.388 62.5536 265 61.5C264.51 59.4546 264.677 57.4546 265.5 55.5Z",
    fill: "#E34F02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.5 56.4999C283.06 55.8913 285.06 57.3913 285.5 60.9999C284.13 64.3787 281.797 65.212 278.5 63.4999C277.073 60.8844 277.406 58.551 279.5 56.4999Z",
    fill: "#EA5203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 59.5C7.2869 60.4767 10.2869 60.81 13.5 60.5C10.3132 61.8056 6.97983 61.8056 3.5 60.5C3.62358 59.8933 3.95691 59.56 4.5 59.5Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5 55.5002C49.2869 54.5235 52.2869 54.1902 55.5 54.5002C55.5 56.5002 55.5 58.5002 55.5 60.5002C58.5 60.5002 61.5 60.5002 64.5 60.5002C61.3752 61.4796 58.0419 61.813 54.5 61.5002C54.5 59.5002 54.5 57.5002 54.5 55.5002C51.8333 55.5002 49.1667 55.5002 46.5 55.5002Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.5 59.5C173.287 60.4767 176.287 60.81 179.5 60.5C176.313 61.8056 172.98 61.8056 169.5 60.5C169.624 59.8933 169.957 59.56 170.5 59.5Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.5 56.5C190.5 57.8333 190.5 59.1667 190.5 60.5C193.833 60.5 197.167 60.5 200.5 60.5C197.038 61.4816 193.371 61.815 189.5 61.5C189.216 59.5853 189.549 57.9187 190.5 56.5Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.5 59.5C207.97 60.4861 212.637 60.8195 217.5 60.5C217.5 60.8333 217.5 61.1667 217.5 61.5C212.456 61.8275 207.456 61.4941 202.5 60.5C202.624 59.8933 202.957 59.56 203.5 59.5Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.5 60.5C218.5 60.5 219.5 60.5 220.5 60.5C219.947 62.5518 218.947 62.8852 217.5 61.5C217.5 61.1667 217.5 60.8333 217.5 60.5Z",
    fill: "#D14A01"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.5 60.5C234.861 61.2032 235.194 62.5365 232.5 64.5C230.358 63.5629 230.024 62.2296 231.5 60.5Z",
    fill: "#E14F04"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.5 62.4998C246.346 62.222 247.68 62.8886 248.5 64.4998C247.68 66.111 246.346 66.7776 244.5 66.4998C244.5 65.1665 244.5 63.8331 244.5 62.4998Z",
    fill: "#DF4F04"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.5 62.5C262.685 62.7224 263.685 64.2224 262.5 67C261.207 67.49 259.873 67.6567 258.5 67.5C258.366 65.7085 258.699 64.0418 259.5 62.5Z",
    fill: "#EA5203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.5 63.5002C276.677 62.8418 278.177 64.5084 277 68.5002C275.333 71.1669 273.667 71.1669 272 68.5002C271.36 66.7352 271.527 65.0685 272.5 63.5002Z",
    fill: "#E44F03"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4998 67.5C55.3368 67.6395 55.6702 68.3061 54.4998 69.5C53.7023 69.0431 53.3689 68.3764 53.4998 67.5Z",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.5 66.5C226.912 66.6941 227.912 68.0274 227.5 70.5C226.5 70.5 225.5 70.5 224.5 70.5C224.5 69.1667 224.5 67.8333 224.5 66.5Z",
    fill: "#D74B04"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.5 67.5C106.337 67.6395 106.67 68.3061 105.5 69.5C104.702 69.0431 104.369 68.3764 104.5 67.5Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.5 68.5C240.166 68.0658 241.333 69.0658 241 71.5C238.342 72.694 237.176 71.694 237.5 68.5Z",
    fill: "#D34B06"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5 71.5C61.1667 71.5 63.8333 71.5 66.5 71.5C65.9816 75.5472 65.1482 79.5472 64 83.5C60.8961 87.0827 57.7294 87.2494 54.5 84C57.5887 85.2279 60.2554 84.5613 62.5 82C54.7663 81.221 53.4329 77.721 58.5 71.5Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.5 68.5C197.057 69.4663 198.39 70.7996 199.5 72.5C198.675 73.3857 197.675 73.719 196.5 73.5C196.682 75.5914 196.348 77.5914 195.5 79.5C196.025 80.1924 196.692 80.6924 197.5 81C196.207 81.49 194.873 81.6567 193.5 81.5C194.357 78.4509 194.357 75.4509 193.5 72.5C194.853 71.4763 195.52 70.143 195.5 68.5Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.5 70.5C252.833 70.5 254.167 70.5 255.5 70.5C255.833 73.5 254.5 74.8333 251.5 74.5C251.5 73.1667 251.5 71.8333 251.5 70.5Z",
    fill: "#D94C03"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.5 70.5C270.161 70.3501 271.161 71.8501 269.5 75C265.707 75.4866 264.707 73.9866 266.5 70.5Z",
    fill: "#EB5203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5 71.5C72.2892 71.5335 75.1226 71.8668 78 72.5C78.2627 75.7803 77.4294 78.7803 75.5 81.5C75.2176 79.0134 75.2176 76.3467 75.5 73.5C73.8561 73.2865 72.3561 73.6198 71 74.5C70.6237 77.0101 69.7904 79.3435 68.5 81.5C67.9371 78.173 68.2704 74.8397 69.5 71.5Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5001 67.4998C94.4973 67.4699 95.164 67.9699 95.5001 68.9998C94.4578 73.2175 93.2911 77.3842 92.0001 81.4998C91.5226 76.7379 92.0226 72.0712 93.5001 67.4998Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.5 71.4998C104.376 71.3689 105.043 71.7023 105.5 72.4998C104.653 75.5537 103.653 78.5537 102.5 81.4998C102.167 80.8331 101.833 80.1665 101.5 79.4998C102.378 76.87 103.045 74.2033 103.5 71.4998Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.5 71.4999C172.238 70.4932 174.238 73.1598 171.5 79.4999C167.562 83.6707 164.228 83.3374 161.5 78.4999C162.071 75.6872 163.404 73.3539 165.5 71.4999Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.5 71.5C177.585 72.3503 179.585 72.6837 181.5 72.5C179.807 73.2283 178.307 74.2283 177 75.5C176.767 77.7801 175.934 79.7801 174.5 81.5C174.167 81.3333 173.833 81.1667 173.5 81C174.61 77.9509 175.277 74.7842 175.5 71.5Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 71.4999C44.5273 71.3378 46.5273 71.5044 48.5 71.9999C49.7112 72.8927 49.7112 73.726 48.5 74.4999C47.1502 73.0498 45.4835 72.3831 43.5 72.4999C43.5 73.4999 43.5 74.4999 43.5 75.4999C47.3315 75.1901 48.8315 76.8568 48 80.4999C44.9032 83.3332 42.0699 83.1665 39.5 79.9999C39.8333 79.4999 40.1667 78.9999 40.5 78.4999C42.1789 80.1044 44.1789 80.771 46.5 80.4999C46.5 79.4999 46.5 78.4999 46.5 77.4999C40.934 77.8247 39.6007 75.8247 42.5 71.4999Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5002 73.5C60.1669 73.5 61.8335 73.5 63.5002 73.5C64.2106 76.8852 63.0439 79.2186 60.0002 80.5C58.2678 80.2664 57.4344 79.2664 57.5002 77.5C57.8459 76.1508 58.1792 74.8175 58.5002 73.5Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.5 71.4999C123.527 71.3378 125.527 71.5044 127.5 71.9999C128.711 72.8927 128.711 73.726 127.5 74.4999C125.5 71.8332 123.5 71.8332 121.5 74.4999C119.693 80.3643 121.36 81.6976 126.5 78.4999C126.833 78.8332 127.167 79.1666 127.5 79.4999C124.96 82.8485 122.127 83.1818 119 80.4999C117.927 76.9002 118.76 73.9002 121.5 71.4999Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.5 71.5C145.458 71.908 147.458 72.2413 149.5 72.5C147.807 73.2283 146.307 74.2283 145 75.5C144.964 77.9412 144.131 79.9412 142.5 81.5C142.167 81.3333 141.833 81.1667 141.5 81C142.61 77.9509 143.277 74.7842 143.5 71.5Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.5 73.5C167.167 73.5 168.833 73.5 170.5 73.5C171.323 78.3394 169.323 80.6728 164.5 80.5C164.298 78.0504 164.631 75.717 165.5 73.5Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.5 71.5C110.5 71.5 113.5 71.5 116.5 71.5C116.693 75.0128 116.026 78.3462 114.5 81.5C113.795 78.911 113.795 76.2443 114.5 73.5C112.856 73.2865 111.356 73.6198 110 74.5C109.319 76.8947 108.485 79.228 107.5 81.5C107.024 78.2605 107.024 74.9271 107.5 71.5Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.5 73.5C210.167 74.1667 210.833 74.8333 211.5 75.5C211.5 77.1667 211.5 78.8333 211.5 80.5C210.833 79.1667 210.167 77.8333 209.5 76.5C209.5 75.5 209.5 74.5 209.5 73.5Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.5 71.4999C140.238 70.4932 142.238 73.1598 139.5 79.4999C137.408 82.1521 134.742 82.9854 131.5 81.9999C128.623 77.8803 129.29 74.3803 133.5 71.4999Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.5 73.5C135.167 73.5 136.833 73.5 138.5 73.5C139.329 78.5011 137.329 80.6678 132.5 80C131.144 77.5859 131.478 75.4193 133.5 73.5Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.5 71.5C154.187 71.3359 156.854 71.5026 159.5 72C161.36 76.1507 160.36 79.484 156.5 82C154.765 82.6514 153.098 82.4847 151.5 81.5C150.833 82.8333 150.167 84.1667 149.5 85.5C148.543 80.6455 149.209 75.9788 151.5 71.5Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.5 73.5C155.167 73.5 156.833 73.5 158.5 73.5C159.036 78.3548 157.036 80.5214 152.5 80C151.144 77.5859 151.478 75.4193 153.5 73.5Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.5 74.5C234.861 75.2032 235.194 76.5365 232.5 78.5C231.571 77.3112 231.238 75.9778 231.5 74.5Z",
    fill: "#D64C05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.5 75.4999C246.995 75.4147 247.995 76.0814 248.5 77.4999C247.68 79.1111 246.346 79.7777 244.5 79.4999C244.433 78.0412 244.766 76.7078 245.5 75.4999Z",
    fill: "#DA4D04"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.5 73.5002C209.5 74.5002 209.5 75.5002 209.5 76.5002C206.972 77.1659 204.306 77.8326 201.5 78.5002C203.577 81.1194 205.743 81.1194 208 78.5002C208.617 79.4493 208.451 80.2827 207.5 81.0002C203.324 83.6318 200.658 82.6318 199.5 78.0002C200.789 71.4222 204.122 69.9222 209.5 73.5002Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.5 73.4999C205.429 73.2307 207.095 73.7307 208.5 74.9999C206.5 75.6666 204.5 75.6666 202.5 74.9999C203.056 74.6173 203.389 74.1173 203.5 73.4999Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5 71.5001C84.7925 71.2437 86.9592 71.577 89 72.5001C88.8481 75.4471 88.6815 78.4471 88.5 81.5001C86.4534 81.5112 84.4534 81.8445 82.5 82.5001C78.4762 81.6454 77.8095 79.812 80.5 77.0001C82.8045 76.1049 85.1378 75.2716 87.5 74.5001C87.1667 73.5001 86.5 72.8334 85.5 72.5001C83.9222 73.6406 82.2555 74.1406 80.5 74.0001C81.3805 73.2918 82.0472 72.4585 82.5 71.5001Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5 77.5C87.969 78.052 87.969 79.052 81.5 80.5C81.5 79.5 81.5 78.5 81.5 77.5Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.5 71.4999C186.527 71.3378 188.527 71.5044 190.5 71.9999C190.957 72.4139 191.291 72.9139 191.5 73.4999C190.915 76.5026 190.248 79.5026 189.5 82.4999C186.681 82.4813 183.847 82.148 181 81.4999C180.289 79.6331 180.789 78.1331 182.5 76.9999C184.935 76.1469 187.269 75.1469 189.5 73.9999C187.407 72.0729 185.407 72.2396 183.5 74.4999C183.167 74.3332 182.833 74.1666 182.5 73.9999C183.381 73.2916 184.047 72.4583 184.5 71.4999Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.5 77.4999C189.72 77.1156 190.054 78.1156 184.5 80.4999C182.197 80.1236 181.863 79.1236 183.5 77.4999Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.5 77.5002C261.5 77.1669 262.833 78.5002 262.5 81.5002C261.167 81.5002 259.833 81.5002 258.5 81.5002C258.5 80.1669 258.5 78.8335 258.5 77.5002Z",
    fill: "#DD4E05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4998 71.4998C53.3762 71.3689 54.0429 71.7023 54.4998 72.4998C53.8739 75.6368 52.8739 78.6368 51.4998 81.4998C50.7685 78.1253 51.1018 74.7919 52.4998 71.4998Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.5 80.5C211.5 78.8333 211.5 77.1667 211.5 75.5C213.355 71.6967 216.188 70.6967 220 72.5C220.36 70.5789 221.194 68.9122 222.5 67.5C222.833 68 223.167 68.5 223.5 69C222.561 73.1984 221.561 77.365 220.5 81.5C218.599 81.4332 216.766 81.7665 215 82.5C213.541 82.1918 212.374 81.5251 211.5 80.5Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.5 73.5C216.167 73.5 217.833 73.5 219.5 73.5C220.323 78.3394 218.323 80.6728 213.5 80.5C213.298 78.0504 213.631 75.717 214.5 73.5Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.5 81.5C241.861 82.2032 242.194 83.5365 239.5 85.5C237.358 84.5629 237.024 83.2296 238.5 81.5Z",
    fill: "#CA4808"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.5 83.5C252.5 83.5 253.5 83.5 254.5 83.5C254.762 84.9778 254.429 86.3112 253.5 87.5C251.889 86.6798 251.222 85.3464 251.5 83.5Z",
    fill: "#E34E01"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.5 89.5C245.5 89.5 246.5 89.5 247.5 89.5C247.762 90.9778 247.429 92.3112 246.5 93.5C244.889 92.6798 244.222 91.3464 244.5 89.5Z",
    fill: "#D94B02"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4265_21614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNsiNew);
export default __webpack_public_path__ + "static/media/NSI_new.1ecbd0994faff103972db53c4190c53f.svg";
export { ForwardRef as ReactComponent };